import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom"
import { app } from "../../../Frame/App";
import { DynPopup } from "../../../Components/DynPopup";
import { WidgetStatistic, TemplateStatus } from "../Widgets/WidgetStatistic";
import { LanguageStringComponent } from "../../../Components/LanguageStringComponent";
import { LanguageString } from "../../../Model/LanguageString";
import { ListView } from "../../../Components/ListView/ListView";
import { INameValue } from "../../../Model/INameValue";
import { RadioButtonComponent } from "../../../Components/RadioButtonComponent";
import { CheckboxCompoment } from "../../../Components/CheckboxComponent";
import { ListItem } from "../../../Model/ListItem";
import { changeGridView } from "../../../site";
import { DropDownComponent } from "../../../Components/DropDownComponent";
import { PopupStatisticsData } from "../Models/PopupStatisticsData";


export type PopupStatisticComponentProps = {
    widget: WidgetStatistic;
}

export class PopupStatisticComponent extends JSXComponent {
    props: PopupStatisticComponentProps;
    templates: ListView;
    title: LanguageStringComponent;
    total: CheckboxCompoment;
    open: CheckboxCompoment;
    categoryId: number;

    inDelay: CheckboxCompoment;
    inProgress: CheckboxCompoment;
    closed: CheckboxCompoment;
    dueSoon: CheckboxCompoment;
    onHold: CheckboxCompoment;
    allStatus: CheckboxCompoment;

    allowedTemplatesList: ListItem[];
    categories: ListItem[];

    constructor(props: PopupStatisticComponentProps) {
        super(props);
    }

    onSave = (): boolean => {
        if (this.title.props.model == null)
            this.title.props.model = new LanguageString();
        this.props.widget.props.title = this.title.props.model;
        this.props.widget.props.templateIds = this.templates.getSelectedIds();
        this.props.widget.props.categoryId = this.categoryId;
        var ids = this.templates.getSelectedItems();
        this.props.widget.recreate();
        return true;
    }

    getData = () => {
        $.ajax({
            url: app.resolveUrl("~/api/measure/getStatisticsPopupData"),
            type: "GET",
            dataType: 'json',
            async: false,
            success: (data: PopupStatisticsData) => {
                this.allowedTemplatesList = data.allowedTemplates;
                this.categories = data.categories;
            },
            error: ((response) => {
                app.addError(response.statusText + ": " + response.responseText);
            })
        });
    }

    renderTemplates(): HTMLElement {
        this.getData();
        this.templates = new ListView({
            name: Resources['WidgetClient'].templates,
            displayProperty: "name",
            idProperty: "id",
            checkedProperty: "checked",
            model: this.allowedTemplatesList,
            allowSelect: true,
            selectedIds: this.props.widget.props.templateIds
        });
        return this.templates.render();
    }

    renderTitle(): HTMLElement {
        this.title = new LanguageStringComponent({
            model: this.props.widget.props.title,
            name: Resources['WidgetClient'].title,
            additionalCssClasses: "name-in-languages",
            maxLength: 250,
            showLabel: true,
            alwaysExpanded: false
        });
        return this.title.render();
    }

    renderTotal(): HTMLElement {
        this.total = new CheckboxCompoment({
            model: this.props.widget.props,
            field: "showTotal",
            label: Resources['WidgetClient'].showTotal,
            createFormGroup: true,
        });
        return this.total.render();
    }

    renderOpen(): HTMLElement {
        this.open = new CheckboxCompoment({
            model: this.props.widget.props,
            field: "showOpen",
            label: Resources['WidgetClient'].showOpen,
            createFormGroup: true,
        });
        return this.open.render();
    }

    onChangeClick = (ev: Event) => {
        let input: HTMLInputElement = (ev.target) as HTMLInputElement;
        let allInput = document.querySelector(".d-status .d-status-all input") as HTMLInputElement;
        // on all click => true? set all checkbox checked : set unchecked
        if (input.parentElement?.parentElement?.classList.contains("d-status-all")) {
            if (input.checked == true)
                this.setAllChecked(true);
            else
                this.setAllChecked(false);
        }
        else {
            if (allInput.checked == true)
                allInput.checked = false;
        }
        this.updateCheckbox();
    }

    updateCheckbox() {
        let checkAll = true;
        let allInput = document.querySelector(".d-status .d-status-all input") as HTMLInputElement;
        document.querySelectorAll(".d-status .d-status-ampel input[type='checkbox']").forEach(e => {
            if ((e as HTMLInputElement).checked == false)
                checkAll = false;
        });

        if (checkAll) {
            allInput.checked = true;
            this.setAllChecked(true);
        }
        else {
            if (allInput.checked == false)
                allInput.checked = false;
            else
                this.setAllChecked(true);
        }
    }

    setAllChecked = (value: boolean) => {
        document.querySelectorAll(".d-status .d-status-ampel input[type='checkbox']").forEach(e => {
            (e as HTMLInputElement).checked = value
        });
    }

    renderStatus(): HTMLElement {
        let div: HTMLElement = <div className="d-status d-flex flex-wrap w-50 justify-content-between"></div>

        // Red ampel
        let delayElem: HTMLElement = <div className="d-flex"></div>
        this.inDelay = new CheckboxCompoment({
            model: this.props.widget.props,
            field: "statusDelayed",
            createFormGroup: true,
            additionalCssClasses: "d-status-ampel",
            changeEvent: this.onChangeClick
        });
        delayElem.appendChild(this.inDelay.render());
        delayElem.appendChild(this.createAmpel("red"));
        div.appendChild(delayElem);

        // Blue ampel
        let planugElem: HTMLElement = <div className="d-flex"></div>
        this.inProgress = new CheckboxCompoment({
            model: this.props.widget.props,
            field: "statusInPlan",
            createFormGroup: true,
            additionalCssClasses: "d-status-ampel",
            changeEvent: this.onChangeClick
        });
        planugElem.appendChild(this.inProgress.render());
        planugElem.appendChild(this.createAmpel("blue"));
        div.appendChild(planugElem);

        // Yellow ampel
        let dueElem: HTMLElement = <div className="d-flex"></div>
        this.dueSoon = new CheckboxCompoment({
            model: this.props.widget.props,
            field: "statusDueSoon",
            createFormGroup: true,
            additionalCssClasses: "d-status-ampel",
            changeEvent: this.onChangeClick
        });
        dueElem.appendChild(this.dueSoon.render());
        dueElem.appendChild(this.createAmpel("yellow"));
        div.appendChild(dueElem);

        // Green ampel
        let closedElem: HTMLElement = <div className="d-flex"></div>
        this.closed = new CheckboxCompoment({
            model: this.props.widget.props,
            field: "statusClosed",
            createFormGroup: true,
            additionalCssClasses: "d-status-ampel",
            changeEvent: this.onChangeClick
        });
        closedElem.appendChild(this.closed.render());
        closedElem.appendChild(this.createAmpel("green"));
        div.appendChild(closedElem);

        // Grey ampel
        let holdElem: HTMLElement = <div className="d-flex"></div>
        this.onHold = new CheckboxCompoment({
            model: this.props.widget.props,
            field: "statusOnHold",
            createFormGroup: true,
            additionalCssClasses: "d-status-ampel",
            changeEvent: this.onChangeClick
        });
        holdElem.appendChild(this.onHold.render());
        holdElem.appendChild(this.createAmpel("onhold"));
        div.appendChild(holdElem);

        this.allStatus = new CheckboxCompoment({
            model: this.props.widget.props,
            field: "statusAll",
            createFormGroup: true,
            label: Resources.Common.all,
            additionalCssClasses: "d-status-all",
            changeEvent: this.onChangeClick
        });
        div.appendChild(this.allStatus.render());

        return div;
    }

    getElement = (): HTMLElement => {
        return <DynPopup size="standard" showCancelButton={true} showSaveButton={true} onSave={this.onSave}
            title={Resources['WidgetClient'].widgetStatistic} cssClass="popup-statistic-component">
            <div className="mb-3">
                {this.renderTitle()}
            </div>
            <div className="mt-4" style={{ height: "10rem" }}>
                <div className="form-group">
                    {this.renderTemplates()}
                </div>
                <div className="d-flex flex-wrap w-50 justify-content-between">
                    {this.renderTotal()}
                    {this.renderOpen()}
                </div>
                <div className="d-flex flex-column">
                    <label className="form-label">{Resources['WidgetClient'].statusChoice}</label>
                    {this.renderStatus()}
                </div>
                <div className="d-flex flex-column">

                    <DropDownComponent model={this}
                        field="categoryId"
                        items={this.categories}
                        valueProperty="id"
                        displayProperty="name"
                        showLabel={true}
                        name={Resources['WidgetClient'].widgetStatisticsUseCategory}
                        infoText={Resources['WidgetClient'].widgetStatisticsUseCategoryInfoText}
                        addEmptyItem={true}
                        id="popupStatisticsCategorySelect"
                        modelValueType="number"
                    />
                </div>
            </div>
        </DynPopup>
    }

    createAmpel(color: string): HTMLElement {
        return <div className={"ampel ampel-" + color}> </div>;
    }

    render(): HTMLElement {
        this.categoryId = this.props.widget.props.categoryId;
        return this.getElement();
    }

}